import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3849e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-6 mb-xl-9 position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "card-header"
}
const _hoisted_3 = { class: "row justify-content-between col-md-12 ml-0 mr-0 d-flex align-items-md-center text-center pt-3 pb-5 align-self-center align-center" }
const _hoisted_4 = { class: "text-gray-800" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  key: 1,
  class: "fas fa-power-off fa-2x text-danger"
}
const _hoisted_8 = { class: "col-md-3 p-6" }
const _hoisted_9 = { class: "text-gray-800" }
const _hoisted_10 = { style: {"font-family":"monospace"} }
const _hoisted_11 = { class: "col-md-3 p-6" }
const _hoisted_12 = { class: "d-flex align-self-center" }
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = { class: "row d-flex align-items-center justify-content-center" }
const _hoisted_15 = { class: "col-md-10" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3,13.5 L19,12 L3,10.5 L3,3.7732928 C3,3.70255344 3.01501031,3.63261921 3.04403925,3.56811047 C3.15735832,3.3162903 3.45336217,3.20401298 3.70518234,3.31733205 L21.9867539,11.5440392 C22.098181,11.5941815 22.1873901,11.6833905 22.2375323,11.7948177 C22.3508514,12.0466378 22.2385741,12.3426417 21.9867539,12.4559608 L3.70518234,20.6826679 C3.64067359,20.7116969 3.57073936,20.7267072 3.5,20.7267072 C3.22385763,20.7267072 3,20.5028496 3,20.2267072 L3,13.5 Z",
        fill: "#4caf50"
      })
    ])
  ])
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-md-3 p-6" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stopwatch fa-2x" }, null, -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_24 = { class: "card-body pt-9 pb-0" }
const _hoisted_25 = { class: "d-flex flex-wrap flex-sm-nowrap mb-6 mr-2" }
const _hoisted_26 = {
  key: 0,
  class: "symbol w-200px bg-light border border-success"
}
const _hoisted_27 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "symbol w-200px bg-light border border-info"
}
const _hoisted_30 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 2,
  class: "symbol w-200px bg-light border border-warning"
}
const _hoisted_33 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 3,
  class: "symbol w-200px bg-light border border-danger"
}
const _hoisted_36 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-100 me-7 mb-4" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  class: "flex-grow-1",
  style: {"margin-left":"20px"}
}
const _hoisted_39 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_40 = { class: "d-flex flex-column" }
const _hoisted_41 = { class: "d-flex align-items-center mb-1" }
const _hoisted_42 = {
  href: "#",
  class: "text-gray-800 fs-2 fw-bolder me-3"
}
const _hoisted_43 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_44 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_45 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_47 = {
  key: 3,
  class: "badge badge-light-success"
}
const _hoisted_48 = {
  key: 4,
  class: "badge badge-light-info"
}
const _hoisted_49 = {
  key: 5,
  class: "badge badge-light-warning"
}
const _hoisted_50 = {
  key: 6,
  class: "badge badge-light-danger"
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_52 = {
  key: 7,
  class: "badge badge-light-primary me-3"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_54 = {
  key: 8,
  class: "badge badge-light-success"
}
const _hoisted_55 = { class: "d-flex col-md-5" }
const _hoisted_56 = { class: "col-md-10 p-6" }
const _hoisted_57 = {
  key: 0,
  class: "text-gray-800"
}
const _hoisted_58 = { class: "col-md-1 icon-position" }
const _hoisted_59 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_60 = { class: "sr-only" }
const _hoisted_61 = {
  key: 1,
  class: "fas fa-play fa-1x"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "d-flex flex-wrap justify-content-start" }
const _hoisted_64 = { class: "d-flex flex-wrap" }
const _hoisted_65 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_66 = { class: "fw-bold fs-6 text-gray-500 mb-4" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-info" }, null, -1))
const _hoisted_68 = { class: "d-flex align-items-center" }
const _hoisted_69 = {
  class: "symbol symbol-25px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": ""
}
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_72 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "15000",
  "data-kt-countup-prefix": "$"
}
const _hoisted_73 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_74 = {
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "Total experience you will earn on completion"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning" }, null, -1))
const _hoisted_76 = { class: "d-flex align-items-center" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_78 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "",
  "data-kt-countup-prefix": "$"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-gray-400" }, "xp", -1))
const _hoisted_80 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_81 = {
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "Total experience you will earn on completion"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu text-primary" }, null, -1))
const _hoisted_83 = { class: "d-flex align-items-center" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_85 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "",
  "data-kt-countup-prefix": "$"
}
const _hoisted_86 = {
  key: 0,
  class: "fab la-windows text-primary fa-1x"
}
const _hoisted_87 = {
  key: 1,
  class: "fab la-linux text-warning fa-1x"
}
const _hoisted_88 = {
  key: 2,
  class: "fab la-apple fa-1x"
}
const _hoisted_89 = {
  key: 3,
  class: "fab la-android text-success fa-1x"
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_91 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.machine.instance && _ctx.machine.instance.is_active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "machine-card-top-btn col-md-3 p-6 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.StopInstance()))
              }, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.shutdown_instance`)), 1),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("i", _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.ip_address`)), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.machine.instance.ip_address), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.send`)) + " flag", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "flag",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.flag_input) = $event)),
                      placeholder: "hackingclub{FLAG}"
                    }, null, 512), [
                      [_vModelText, _ctx.flag_input]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("i", {
                      class: "cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFlag()))
                    }, _hoisted_18)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.time_remaining`)), 1),
                _hoisted_21,
                _createElementVNode("b", {
                  title: _ctx.$t(`${_ctx.currentLanguage}.machine.time_remaining_machine`)
                }, " " + _toDisplayString(_ctx.countdown || "0d 00h 00m 00s"), 9, _hoisted_22)
              ])
            ]),
            _hoisted_23
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_ctx.machine.dificulty == 'easy')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    class: "mw-50px mw-lg-75px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_28)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'medium')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    class: "mw-50px mw-lg-75px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_31)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'hard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("img", {
                    class: "mw-50px mw-lg-75px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_34)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'insane')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    class: "mw-50px mw-lg-150px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_37)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.machine.name), 1),
                  (
                      _ctx.machine.completion_percentage > 0 &&
                      _ctx.machine.completion_percentage < 100
                    )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.completion_percentage == 100)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.completed`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.completion_percentage == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.not_started_yet`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_46,
                  (_ctx.machine.dificulty == 'easy')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.easy`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'medium')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.medium`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'hard')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.hard`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'insane')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.insane`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_51,
                  (_ctx.machine.type == 'certification')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, "certification"))
                    : _createCommentVNode("", true),
                  _hoisted_53,
                  (_ctx.machine.is_freemium)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Free"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  (_ctx.release_countdown)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_57, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.release_in`)) + "  " + _toDisplayString(_ctx.release_countdown || "00:00:00"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", null, [
                    (!_ctx.machine.instance)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.StartInstance())),
                          class: "btn btn-light-success",
                          id: "start_instance_btn"
                        }, [
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_61))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.machine.type == 'certification')
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machine.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "badge badge-light-dark me-3 mb-3"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.creator`)) + " ", 1),
                    _hoisted_67
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      (_ctx.machine.creator)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: 
                          _ctx.machine.creator.avatar || '/media/avatars/blank.png'
                        
                          }, null, 8, _hoisted_70))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.machine.creator.nick || 'No nick'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createTextVNode(" Total " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.of`)) + " XP ", 1),
                    _hoisted_75
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("div", _hoisted_78, [
                      _createTextVNode(_toDisplayString(_ctx.machine.xp) + " ", 1),
                      _hoisted_79
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.operacional_system`)) + " ", 1),
                    _hoisted_82
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      (_ctx.machine.os_name == 'windows')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_86))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'linux')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_87))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'osx')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_88))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'androiud')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_89))
                        : _createCommentVNode("", true),
                      _hoisted_90,
                      _createElementVNode("small", _hoisted_91, _toDisplayString(_ctx.machine.os_name), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}